import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const SettingFilter = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path d="M18 5H21" />
      <path d="M3 5H14" />
      <path d="M10 12H21" />
      <path d="M3 12H6" />
      <path d="M18 19H21" />
      <path d="M3 19H14" />
      <path d="M17.4142 3.58579C18.1953 4.36684 18.1953 5.63317 17.4142 6.41422C16.6332 7.19527 15.3668 7.19527 14.5858 6.41422C13.8047 5.63317 13.8047 4.36684 14.5858 3.58579C15.3668 2.80474 16.6332 2.80474 17.4142 3.58579" />
      <path d="M9.41421 10.5858C10.1953 11.3668 10.1953 12.6332 9.41421 13.4142C8.63316 14.1953 7.36683 14.1953 6.58578 13.4142C5.80473 12.6332 5.80473 11.3668 6.58578 10.5858C7.36683 9.80474 8.63316 9.80474 9.41421 10.5858" />
      <path d="M17.4142 17.5858C18.1953 18.3668 18.1953 19.6332 17.4142 20.4142C16.6332 21.1953 15.3668 21.1953 14.5858 20.4142C13.8047 19.6332 13.8047 18.3668 14.5858 17.5858C15.3668 16.8047 16.6332 16.8047 17.4142 17.5858" />
    </svg>
  );
};
